<template>
	<div>
		<modalconfirm ref="modalconfirmCustomer" @action="proccessCustomer"/>
		<DetailRequirement ref="DetailRequirement" :data="arrayMitra" :title="titleDetail"></DetailRequirement>
		<StockistArea ref="StockistArea" :data="customerArea" :title="titleDetail"></StockistArea>
		<div class="text-h5">Tambah Pra MB</div>
		<v-card class="mt-3" outlined>
			<v-card-text>
				<v-row>
					<v-col cols="12" sm="6" md="6" class="py-0">
						<v-row>
							<v-col cols="12" md="12">
								<v-text-field v-model="gs_code" label="Kode Mitra" outlined dense></v-text-field>
								<div class="text-right">
									<v-btn light depressed color="primary" @click="cek">
										<div class="pl-2 text-capitalize">Cek Mitra</div>
									</v-btn>
								</div>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" sm="6" md="6" class="py-4" v-if="dataGS.status == true">
						<v-row class="ml-3" justify="center">
							<div justify="center" align="center" v-if="false">
								<v-chip outlined color="primary" @click="showHU">
									Join 7 HU
									<v-icon v-if="dataGS.requirements.hu.valid == true" dark color="green">mdi-check-circle</v-icon>
									<v-icon v-else dark color="pink">mdi-close-circle</v-icon>
								</v-chip>
							</div>
							<div justify="center" align="center" class="ml-3" v-if="false">
								<v-chip outlined color="primary" @click="showSponsor">
									Sponsor 10 HU
									<v-icon v-if="dataGS.requirements.sponsor.valid == true" dark color="green">mdi-check-circle</v-icon>
									<v-icon v-else dark color="pink">mdi-close-circle</v-icon>
								</v-chip>
							</div>
							<div class="d-flex flex-column ml-3">
								<v-chip outlined color="primary" :disabled="!city" @click="showStockist">
									Review MB Terdekat
								</v-chip>
								<div class="d-flex justify-center">
									<v-checkbox label="Setujui" color="primary" v-model="approvedCity" hide-details>
									</v-checkbox>
								</div>
							</div>
						</v-row>
					</v-col>
				</v-row>
				<v-row v-if="dataGS.status == true">
					<v-col cols="12" sm="6" md="6" class="py-0">
						<v-row>
							<v-col cols="12" md="12" class="pt-0">
								<v-card class="mt-3" outlined>
									<v-card-title>
										Informasi Mitra
									</v-card-title>
									<v-card-text>
										<v-text-field v-model="mb_code" :rules="[inputrules.required]" label="Kode MB" outlined dense @focus="() => responseError.network_code=''" :error-messages="responseError.network_code"></v-text-field>
										<v-text-field v-model="name" :rules="[inputrules.required]" label="Nama Mitra" outlined dense @focus="() => responseError.name=''" :error-messages="responseError.name"></v-text-field>
										<v-text-field v-model="email" :rules="[inputrules.required]" label="Email" outlined dense @focus="() => responseError.email=''" :error-messages="responseError.email"></v-text-field>
										<v-textarea v-model="address" :rules="[inputrules.required]" label="Alamat" outlined dense @focus="() => responseError.address=''" :error-messages="responseError.address"></v-textarea>
										<v-autocomplete v-model="province" :rules="[inputrules.required]" label="Provinsi" no-data-text="Tidak ada data yang sesuai" outlined dense @focus="() => responseError.province_id=''" :error-messages="responseError.province_id" :items="listProvince" item-text="province" return-object @change="changeProvince"></v-autocomplete>
										<v-autocomplete v-model="city" :rules="[inputrules.required]" label="Kota" no-data-text="Pilih provinsi terlebih dahulu" outlined dense @focus="() => responseError.city_id=''" :error-messages="responseError.city_id" :items="listCity" :item-text="item => item.type + ' ' + item.city_name" item-value="city_id" return-object @change="changeCity"></v-autocomplete>
										<v-autocomplete v-model="subdistrict" :rules="[inputrules.required]" label="Kecamatan" no-data-text="Pilih kota terlebih dahulu" outlined dense @focus="() => responseError.subdistrict_id=''" :error-messages="responseError.subdistrict_id" :items="listSubdistrict" item-text="subdistrict_name" return-object></v-autocomplete>
										<v-text-field v-model="mobilephone" :rules="[inputrules.required]" label="No Telepon" outlined dense @focus="() => responseError.mobilephone=''" :error-messages="responseError.mobilephone"></v-text-field>
										<v-text-field v-model="mobilephone2" label="No Telepon 2 (optional)" outlined dense @focus="() => responseError.mobilephone2=''" :error-messages="responseError.mobilephone2"></v-text-field>
										<v-text-field v-model="ktp" label="KTP" outlined dense disabled></v-text-field>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" sm="6" md="6" class="py-0">
						<v-row>
							<v-col cols="12" md="12" class="pt-0">
								<v-card class="mt-3" outlined>
									<v-card-title>
										Opsi Lainnya
									</v-card-title>
									<v-card-text>
										<v-col col="12">
											<div v-for="(item, index) in requirement" :key="index">
												<v-checkbox v-model="requirementcheck" :value="item" :label="item" color="primary" hide-details></v-checkbox>
											</div>
										</v-col>
									</v-card-text>
								</v-card>
							</v-col>
							<v-col cols="12" md="12">
								<v-textarea v-model="note" label="Catatan" outlined dense @focus="() => responseError.note=''" :error-messages="responseError.note">
								</v-textarea>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions v-if="dataGS.status == true">
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" outlined class="text-capitalize mr-5" @click="confirmRejectCustomer">Tolak</v-btn>
				<v-btn v-if="allRequirementComplete" color="primary darken-1" depressed class="text-capitalize" @click="confirmAddCustomer">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import DetailRequirement from '@/views/MLwarehouse/customer/DetailRequirement'
import StockistArea from '@/views/MLwarehouse/customer/StockistArea'

export default {
	components: {
		DetailRequirement, StockistArea
	},
	data() {
		return {
			action: '',
			gs_code: "",
			mb_code: "",
			network_id: "",
			name: '',
			email: '',
			address: '',
			province: '',
			city: '',
			subdistrict: '',
			mobilephone: '',
			mobilephone2: '',
			ktp: '',
			note: '',
			requirementcheck: [],
			arrayMitra: [],
			titleDetail: '',
			approvedCity: false,
			listProvince: [],
			listCity: [],
			listSubdistrict: [],
		}
	},
	computed: {
		...mapState('customerList', ['requirement', 'customerArea', 'dataGS', 'response', 'responseError']),

		allRequirementComplete() {
			let complete = false
			if (this.dataGS.status == true) {
				complete =
          this.requirementcheck.length == this.requirement.length
          // && this.dataGS.requirements.sponsor.valid == true
          // && this.dataGS.requirements.hu.valid == true
          && this.approvedCity == true
			}
			return complete
		}
	},
	methods: {
		...mapActions('customerList', ['getRegistrationRequirements', 'checkgs', 'getOptionProvince', 'getOptionCity', 'getOptionSubdistrict', 'rejectCustomer', 'addCustomer', 'getCustomerArea']),
		...mapMutations('customerList', ['setDataGS', 'clearDataCustomer', 'saveResponse']),
		...mapMutations(['setOverlay']),

		cek() {
			this.checkgs({
				gs: this.gs_code
			}).then(() => {
				if (this.dataGS.status == true) {
					let gs_code = this.gs_code.toUpperCase()
					this.mb_code = gs_code.replace('GS', 'MB')
					this.name = this.dataGS.name
					this.email = this.dataGS.email
					this.address = this.dataGS.address
					this.province = ''
					this.city = ''
					this.subdistrict = ''
					this.mobilephone = this.dataGS.mobilephone
					this.mobilephone2 = ''
					this.ktp = this.dataGS.ktp
					this.requirementcheck = []
					this.note = ''
					this.approvedCity = false
				}
			})
		},
		showHU() {
			this.arrayMitra = this.dataGS.requirements.hu.data
			this.titleDetail = 'Syarat Hak Usaha'
			this.$refs.DetailRequirement.showDialog()
		},
		showSponsor() {
			this.arrayMitra = this.dataGS.requirements.sponsor.data
			this.titleDetail = 'Syarat Sponsorisasi'
			this.$refs.DetailRequirement.showDialog()
		},
		showStockist() {
			this.titleDetail = `Mobile Counter di ${this.city.type} ${this.city.city_name}`
			this.$refs.StockistArea.showDialog()
		},
		async changeProvince() {
			this.listCity = [... await this.getOptionCity(this.province.province_id)]
			this.listSubdistrict = []
			this.city = ''
			this.subdistrict = ''
		},
		async changeCity() {
			this.listSubdistrict = [... await this.getOptionSubdistrict(this.city.city_id)]
			await this.getCustomerArea({city_id: this.city.city_id})
			this.subdistrict = ''
		},
		confirmRejectCustomer() {
			this.action = 'reject'
			this.$refs.modalconfirmCustomer.setMessage('Apakah Anda yakin akan menolak Mitra ini menjadi pra-mb?')
			this.$refs.modalconfirmCustomer.showConfirm()
		},
		confirmAddCustomer() {
			this.action = 'add'
			this.$refs.modalconfirmCustomer.setMessage('Apakah Anda yakin akan menyetujui Mitra ini menjadi pra-mb?')
			this.$refs.modalconfirmCustomer.showConfirm()
		},
		async proccessCustomer() {
			if (this.action == 'add') {
				await this.add()
			} else {
				await this.reject()
			}
		},
		async reject() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmCustomer.hideConfirm()
			let data = await {
				network_id : this.dataGS.network_id,
				network_mid : this.gs_code,
				network_code : this.mb_code,
				name : this.name,
				email : this.email,
				mobilephone : this.mobilephone,
				mobilephone2 : this.mobilephone2,
				ktp : this.ktp,
				province_id : this.province.province_id,
				province_name : this.province.province,
				city_id : this.city.city_id,
				city_name : this.city.city_name,
				subdistrict_id : this.subdistrict.subdistrict_id,
				subdistrict_name : this.subdistrict.subdistrict_name,
				address : this.address,
				level : 'pra_mb'
			}
			let params = await {
				network_mid: this.gs_code,
				requirement: JSON.stringify({
					requirement: this.requirementcheck,
					network: {
						hu: this.dataGS.requirements.hu.valid,
						sponsor: this.dataGS.requirements.sponsor.valid,
						approvedCity: this.approvedCity
					}
				}),
				params: JSON.stringify(data),
				note: this.note,
			}
			await this.rejectCustomer(params).then( () => {
				if (this.response.code == 200) {
					this.gs_code = ''
					this.resetData()
				}
			})
			await this.setOverlay(false)
		},
		async add() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmCustomer.hideConfirm()
			let data = await {
				network_id : this.dataGS.network_id,
				network_mid : this.gs_code,
				network_code : this.mb_code,
				name : this.name,
				email : this.email,
				mobilephone : this.mobilephone,
				mobilephone2 : this.mobilephone2,
				ktp : this.ktp,
				province_id : this.province.province_id,
				province_name : this.province.province,
				city_id : this.city.city_id,
				city_name : this.city.city_name,
				subdistrict_id : this.subdistrict.subdistrict_id,
				subdistrict_name : this.subdistrict.subdistrict_name,
				address : this.address,
				level : 'pramb',
				note: this.note,
			}
			let params = await Object.assign({}, data)
			params['requirement'] = await JSON.stringify({
				requirement: this.requirementcheck,
				network: {
					hu: this.dataGS.requirements.hu.valid,
					sponsor: this.dataGS.requirements.sponsor.valid,
					approvedCity: this.approvedCity
				}
			})
			params['params'] = await  JSON.stringify(data)
			await this.addCustomer(params).then( () => {
				if (this.response.code == 200) {
					this.gs_code = ''
					this.resetData()
				}
			})
			await this.setOverlay(false)
		},
		resetData() {
			this.saveResponse({})
			this.setDataGS({})
			this.gs_code = ""
			this.mb_code = ""
			this.network_id = ""
			this.name = ''
			this.email = ''
			this.address = ''
			this.province = ''
			this.city = ''
			this.subdistrict = ''
			this.mobilephone = ''
			this.mobilephone2 = ''
			this.ktp = ''
			this.note = ''
			this.requirementcheck = []
			this.approvedCity = false
		}
	},
	watch: {
		gs_code(val) {
			this.gs_code = val.toUpperCase()
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Tambah Pra MB`)
		this.getRegistrationRequirements()
		this.listProvince = [...await this.getOptionProvince()]
	},
	beforeDestroy() {
		this.clearDataCustomer()
	}
}
</script>
